import React, { useState } from "react";
import PrimaryButton from "../../Components/Common/PrimaryButton";
import moment from "moment";
import { useHistory } from "react-router";
import "./linkRegister.css";
import AddIcon from "@mui/icons-material/Add";
import dayjs from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Card from "@mui/material/Card";

import commoncss from "../../myfin_v2/css/common.module.css";
import buttoncss from "../../myfin_v2/css/button.module.css";
import linkRegcss from "../../myfin_v2/css/linkReg.module.css";
import { Button } from "../../myfin_v2/elements/Button";
import InputGroup from "../../myfin_v2/elements/InputGroup";
import { ReactComponent as CalenderIcon } from "../../myfin_v2/assets/icons/calender.svg";
import MapRegModal from "./MapRegModal";
import CompanySVGComponent from "../../Components/Common/SVGComponents/CompanySVGComponent";
import { ReactComponent as PlusIcon } from "../../myfin_v2/assets/icons/plusBlack.svg";

const LinkRegisterTable = ({
  keyElement,
  data,
  AddNewTableRow,
  handleDrop,
  HandleChange,
  HandleMapping,
  selInvestmentRegCY,
  selInvestmentRegPY,
  selRecRegCY,
  selRecRegPY,
  selPayRegCY,
  selPayRegPY,
  selLoanRegCY,
  selLoanRegPY,
  selLoanPrecedingYear,
  selLeaseRegCY,
  selLeaseRegPY,
  selFixedAssetsRegCY,
  selFixedAssetsRegPY,
  selSalesRegCY,
  selSalesRegPY,
  selPurchaseRegCY,
  selPurchaseRegPY,
}) => {
  const history = useHistory();
  const [mapRegModal, setMapRegModal] = useState(false);
  const [mapCategory, setMapCategory] = useState(null);

  const hasThreeYears = keyElement === "loans";
  const hasSingleContainer = ["investment", "lease"].includes(keyElement);

  const renderRegisterItems = (items, keyElement, rowIndex, yearType) => {
    if (!Array.isArray(items) || items.length === 0) {
      return (
        <div
          style={{
          position: "relative",
          borderRadius: "8px",
          padding: "0 20px",
          textAlign: "center",
          backgroundColor: "#F4FAF5",
          height: "80px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%23A0DABC' stroke-width='2' stroke-dasharray='12 8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`,
        }}
        >
          <span
            style={{
              color: "#C4D1CE",
              fontSize: "12px",
              fontWeight: "400",
            }}
          >
            Drag and drop your file here
          </span>
        </div>
      );
    }

    return items.map((ele, idx) => (
      <div
        key={ele?.data?._id || idx}
        draggable
        className={`d-flex p-2 bg-white cursor-pointer ${linkRegcss.importRegCard} ${
          ["receivable", "payable", "fixed assets", "sales", "purchase"].includes(keyElement)
            ? linkRegcss.tagCodesEmded
            : ""
        }`}
        style={{
          borderRadius: "8px",
          border: "1px solid #EAEEED",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "8px",
        }}
      >
        <div className="p-2">
          <p className="m-0 p-1 text-left" style={{ paddingLeft: "20px", fontSize: "14px", fontWeight: "500", color: "#162F28" }}>
            {ele?.data?.name}
          </p>

          <p className="m-0 p-0 d-flex align-items-center" style={{ fontSize: "13px", color: "#809790", marginTop: "-3px" }}>
            {/* <CompanySVGComponent color="#ABA9A9" width={10} height={13} /> */}
            <span className={`ml-1 ${linkRegcss.truncateLength}`}>
              {ele?.data?.companyData?.company_name}
            </span>

            <CalenderIcon className="ml-1" style={{ height: "16px", width: "16px", color: "#809790", marginTop: "-2px" }} />
            <span className="ml-1">
              {moment(ele?.data?.createdAt).format("DD-MMM-YYYY")}
            </span>
          </p>
        </div>
        <div style={{ paddingRight: "10px"}}>
        {["receivable", "payable", "fixed assets", "sales", "purchase"].includes(keyElement) && (
          <Button
            btnColor={`${buttoncss.secondary} ${buttoncss.subBtn}`}
            style={{
              alignSelf: "center",
              fontSize: "12px",
              padding: "6px 12px",
              borderRadius: "6px",
              height: "28px",
            }}
            label="Tag Codes"
            onClick={() => {
              const routeMap = {
                receivable: "receivable",
                payable: "payable",
                "fixed assets": "fixed asset",
                sales: "sale",
                purchase: "purchase",
              };
              history.push(`/tag-codes/${routeMap[keyElement]}/${ele?.data?._id}`);
            }}
          />
        )}
        </div>
      </div>
    ));
  };

  // Get register data helper
  const getRegisterData = (keyElement) => {
    const dataMap = {
      lease: { cy: selLeaseRegCY, py: selLeaseRegPY },
      loans: { cy: selLoanRegCY, py: selLoanRegPY, preceding_year: selLoanPrecedingYear },
      investment: { cy: selInvestmentRegCY, py: selInvestmentRegPY },
      receivable: { cy: selRecRegCY, py: selRecRegPY },
      payable: { cy: selPayRegCY, py: selPayRegPY },
      "fixed assets": { cy: selFixedAssetsRegCY, py: selFixedAssetsRegPY },
      sales: { cy: selSalesRegCY, py: selSalesRegPY },
      purchase: { cy: selPurchaseRegCY, py: selPurchaseRegPY },
    };

    return dataMap[keyElement] || { cy: [], py: [] };
  };

  const registerData = getRegisterData(keyElement);

  return (
    <React.Fragment key={keyElement}>
      <div
        className="mt-4"
        style={{
          border: "1px solid #Eaeeed",
          borderRadius: "10px",
          padding: "20px",
          position: "relative",
          backgroundColor: "#FFFFFF",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <p
            className={`header text-capitalize m-0 ${linkRegcss.header} ${commoncss.fw500}`}
            style={{ fontSize: "16px", color: "#33584E",fontWeight: "700" }}
          >
            {keyElement}
          </p>

          <div style={{ display: "flex", gap: "8px" }}>
            <button
            style={{
              width: "60px",
              height: "33px",
              padding: "0 16px",
              borderRadius: "6px",
              backgroundColor: "#03565A",
              color: "#FFFFFF",
              fontFamily: "DM Sans",
              fontSize: "14px",
              fontWeight: "500",
              lineHeight: "100%",
              letterSpacing: "0px",
              border: "none",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
            }}
            onClick={() => {
              const categoryMap = {
                lease: "lease",
                loans: "loans",
                receivable: "receivable",
                payable: "payable",
                "fixed assets": "fixed_assets",
                sales: "sales",
                purchase: "purchase",
                investment: "investment",
              };

              setMapCategory(categoryMap[keyElement]);
              setMapRegModal(true);
            }}
          >
            Map
          </button>

            <Button
              btnColor={buttoncss.secondary}
              label={
                <>
                  <PlusIcon style={{ width: "16px", height: "16px" }} />
                  <span>Add Slot</span>
                </>
              }
              style={{
                fontSize: "14px",
                padding: "10px 12px",
                borderRadius: "6px",
                height: "33px",
                display: "flex",
                alignItems: "center",
              }}
              onClick={() => AddNewTableRow(keyElement)}
            />
          </div>
        </div>
        {data[keyElement]?.length > 0 && (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: hasThreeYears ? "1fr 1fr 1fr" : hasSingleContainer ? "1fr" : "1fr 1fr",
              gap: "20px",
            }}
          >
            <div
              style={{
                border: "1px solid #EAEEED",
                borderRadius: "8px",
                padding: "12px",
                backgroundColor: "#FFFFFF",
              }}
            >
                {!hasSingleContainer && (
                  <div
                    style={{
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#111111",
                      marginBottom: "12px",
                    }}
                  >
                    Current Year
                  </div>
                )}

              {data[keyElement].map((dataEle, ix) => {
                const rowCYData =
                  registerData.cy[ix]?.length > 0
                    ? registerData.cy[ix]
                    : Array.isArray(dataEle?.cy)
                      ? dataEle.cy.map((d) => ({ data: d }))
                      : [];

                return (
                  <div
                    key={ix}
                    style={{ marginBottom: ix < data[keyElement].length - 1 ? "12px" : "0" }}
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => handleDrop(e, keyElement, ix, "cy")}
                  >
                    {Array.isArray(dataEle?.cy) ? (
                      renderRegisterItems(rowCYData, keyElement, ix, "cy")
                    ) : (
                      <DisabledDate value={dataEle?.cy} />
                    )}
                  </div>
                );
              })}
            </div>

            {/* Previous Year Container */}
            {!hasSingleContainer ? (
              <div
                style={{
                  border: "1px solid #EAEEED",
                  borderRadius: "8px",
                  padding: "12px",
                  backgroundColor: "#FFFFFF",
                }}
              >
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#111111",
                    marginBottom: "12px",
                  }}
                >
                  Previous Year
                </div>

                {data[keyElement].map((dataEle, ix) => {
                  const rowPYData =
                    registerData.py[ix]?.length > 0
                      ? registerData.py[ix]
                      : Array.isArray(dataEle?.py)
                        ? dataEle.py.map((d) => ({ data: d }))
                        : [];

                  return (
                    <div
                      key={ix}
                      style={{ marginBottom: ix < data[keyElement].length - 1 ? "12px" : "0" }}
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => handleDrop(e, keyElement, ix, "py")}
                    >
                      {Array.isArray(dataEle?.py) ? (
                        renderRegisterItems(rowPYData, keyElement, ix, "py")
                      ) : (
                        <DisabledDate value={dataEle?.py} />
                      )}
                    </div>
                  );
                })}
              </div>
            ) : (
              <>
                {/* Previous Year container hidden for investment and lease */}
              </>
            )}

            {/* Preceding Year Container (only for loans) */}
            {hasThreeYears && (
              <div
                style={{
                  border: "1px solid #EAEEED",
                  borderRadius: "8px",
                  padding: "12px",
                  backgroundColor: "#FFFFFF",
                }}
              >
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#111111",
                    marginBottom: "12px",
                  }}
                >
                  Preceding Year
                </div>

                {data[keyElement].map((dataEle, ix) => {
                  const rowPrecedingYData =
                    registerData.preceding_year?.[ix]?.length > 0
                      ? registerData.preceding_year[ix]
                      : Array.isArray(dataEle?.preceding_year)
                        ? dataEle.preceding_year.map((d) => ({ data: d }))
                        : [];

                  return (
                    <div
                      key={ix}
                      style={{ marginBottom: ix < data[keyElement].length - 1 ? "12px" : "0" }}
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => handleDrop(e, keyElement, ix, "preceding_year")}
                    >
                      {Array.isArray(dataEle?.preceding_year) ? (
                        renderRegisterItems(rowPrecedingYData, keyElement, ix, "preceding_year")
                      ) : (
                        <DisabledDate value={dataEle?.preceding_year} />
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}
      </div>

      {mapRegModal && (
        <MapRegModal
          setMapRegModal={setMapRegModal}
          mapCategory={mapCategory}
          setMapCategory={setMapCategory}
          selRecRegCY={selRecRegCY}
          selRecRegPY={selRecRegPY}
          selPayRegCY={selPayRegCY}
          selPayRegPY={selPayRegPY}
          selLoanRegCY={selLoanRegCY}
          selLoanRegPY={selLoanRegPY}
          selLoanPrecedingYear={selLoanPrecedingYear}
          selLeaseRegCY={selLeaseRegCY}
          selLeaseRegPY={selLeaseRegPY}
          selFixedAssetsRegCY={selFixedAssetsRegCY}
          selFixedAssetsRegPY={selFixedAssetsRegPY}
          selSalesRegCY={selSalesRegCY}
          selSalesRegPY={selSalesRegPY}
          selPurchaseRegCY={selPurchaseRegCY}
          selPurchaseRegPY={selPurchaseRegPY}
          selInvestmentRegCY={selInvestmentRegCY}
          selInvestmentRegPY={selInvestmentRegPY}
        />
      )}
    </React.Fragment>
  );
};

const DisabledDate = ({ value }) => (
  <InputGroup
    class_={commoncss.widthFC}
    inputs={[
      <>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={["DatePicker", "MobileDatePicker"]}>
            <MobileDatePicker
              className={`${commoncss.datePickerContainer} ${commoncss.clickable}`}
              disabled
              value={dayjs(value)}
              sx={{
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
                "& .MuiInputBase-input": {
                  fontSize: "12px",
                },
              }}
            />
          </DemoContainer>
         <span className="icon">
          <CalenderIcon className="vaMiddle" width={16} height={16} />
        </span>
        </LocalizationProvider>
        
      </>,
    ]}
  />
);

export default LinkRegisterTable;